<div class="notifications-container">
  <div class="header">
    <h2>Notification Management</h2>
  </div>

  <div class="row">
    <!-- Notification Settings -->
    <div class="col-md-5">
      <div class="card settings-card">
        <div class="card-header">
          <h5>Notification Settings</h5>
        </div>
        <div class="card-body">
          <form (ngSubmit)="saveSettings()">
            <div class="form-group">
              <label for="documentExpiryDays">Document Expiry Reminder Days</label>
              <input
                id="documentExpiryDays"
                type="text"
                class="form-control"
                [(ngModel)]="documentExpiryDays"
                name="documentExpiryDays"
                placeholder="e.g., 30, 15, 7, 1">
              <small class="form-text text-muted">
                Comma-separated days before expiry to send reminders
              </small>
            </div>

            <div class="form-group">
              <label for="birthdayReminderDays">Birthday Reminder Days</label>
              <input
                id="birthdayReminderDays"
                type="number"
                class="form-control"
                [(ngModel)]="birthdayReminderDays"
                name="birthdayReminderDays"
                min="0" max="30">
              <small class="form-text text-muted">
                Days before birthday to send reminders
              </small>
            </div>

            <div class="form-group">
              <label for="anniversaryReminderDays">Work Anniversary Reminder Days</label>
              <input
                id="anniversaryReminderDays"
                type="number"
                class="form-control"
                [(ngModel)]="anniversaryReminderDays"
                name="anniversaryReminderDays"
                min="0" max="30">
              <small class="form-text text-muted">
                Days before work anniversary to send reminders
              </small>
            </div>

            <div class="form-group">
              <label for="notificationChannel">Default Notification Channel</label>
              <select
                id="notificationChannel"
                class="form-control"
                [(ngModel)]="notificationChannel"
                name="notificationChannel">
                <option *ngFor="let channel of notificationChannels" [value]="channel">
                  {{ getChannelLabel(channel) }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="hrEmails">HR Email Addresses</label>
              <input
                id="hrEmails"
                type="text"
                class="form-control"
                [(ngModel)]="hrEmails"
                name="hrEmails"
                placeholder="e.g., hr@company.com, manager@company.com">
              <small class="form-text text-muted">
                Comma-separated email addresses of HR staff to receive notifications
              </small>
            </div>

            <div class="form-group text-right">
              <button type="button" class="btn btn-secondary mr-2" (click)="testNotifications()">
                Test Notifications
              </button>
              <button type="submit" class="btn btn-primary">
                Save Settings
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Notification History -->
    <div class="col-md-7">
      <div class="card history-card">
        <div class="card-header">
          <h5>Notification History</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Recipient</th>
                  <th>Sent Date</th>
                  <th>Status</th>
                  <th>Channel</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let notification of notifications$ | async">
                  <td>
                    <span [ngClass]="{'text-warning': notification.notificationType === 'documentExpiring',
                                      'text-danger': notification.notificationType === 'documentExpired',
                                      'text-info': notification.notificationType === 'birthday',
                                      'text-success': notification.notificationType === 'workAnniversary'}">
                      {{ getNotificationTypeLabel(notification.notificationType) }}
                    </span>
                    <small *ngIf="notification.documentTitle" class="d-block text-muted">
                      {{ notification.documentTitle }}
                    </small>
                  </td>
                  <td>{{ getEmployeeName(notification.employeeId) | async }}</td>
                  <td>{{ formatDate(notification.sentDate) }}</td>
                  <td>
                    <span class="badge" [ngClass]="notification.success ? 'bg-success' : 'bg-danger'">
                      {{ notification.success ? 'Delivered' : 'Failed' }}
                    </span>
                  </td>
                  <td>{{ getChannelLabel(notification.channel) }}</td>
                </tr>
                <tr *ngIf="(notifications$ | async)?.length === 0">
                  <td colspan="5" class="text-center">No notification history available.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
